import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { getServiceFilterParams } from '@/pages/dashboard/utils/utils';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { dynamicString } from '@home/utils/dynamicString';
import { getDefaultUtcDateValue } from '@/pages/dashboard/utils/dateUtils';

const MapService = (props: any) => {
  const {
    children,
    api,
    refreshKey = '',
    interval,
    metricsParams,
    ...resetProps
  } = props || {};
  const contextObj = useContext(FilterContext);
  const { filterVal, filterLoading } = contextObj || {};
  const gameCode = useSelector(
    (state: any) => state?.dashboard?.currentGame?.game_code,
    shallowEqual,
  );

  const data = useMemo(
    () => ({
      game_code: gameCode,
      metric: resetProps.data?.metric,
    }),
    [gameCode, resetProps.data?.metric],
  );

  return (
    <Service
      api={api}
      data={data}
      refreshKey={refreshKey}
      interval={interval}
      dataKey={'data'}
      beforeRequest={(data) => {
        const { filterVal, game_code, metric } = data;
        const defaultTimeRange = getDefaultUtcDateValue(filterVal?.timeType, filterVal?.rangeTime);
        const filterParams = getServiceFilterParams(
          filterVal,
          defaultTimeRange,
        );
        let by_type = 'map_star';
        if (metric !== 'wow_map_cnt') {
          by_type = 'map_tag';
        }
        const params = {
          game_code,
          by_type,
          metric,
          ...filterParams,
        };
        return params;
      }}
      trackData={['game_code', 'metric']}
      formatData={(res) => {
        // 自定义名称
        const isCustomName =
          res?.dwm_data_list?.[0]?.metrics === metricsParams?.key;
        return {
          dwm_data_list: res?.dwm_data_list?.map((item: any) => {
            const list = [...item?.list];
            // 把其他放到最后
            const otherIndex = list.findIndex(
              (val) => val?.full_crz_name === '其他',
            );
            if (otherIndex !== -1) {
              list.push(...list.splice(otherIndex, 1));
            }
            return {
              ...item,
              list: list.map((val: any) => ({
                ...val,
                full_crz_name: isCustomName
                  ? dynamicString(metricsParams?.customName, val)
                  : val?.full_crz_name,
              })),
            };
          }),
          dwm_list: res?.dwm_list,
        };
      }}
    >
      {
        // 保证是jsx数组，而不是其他类型数组
        React.Children.map(children, (child: any) =>
          React.cloneElement(child, {
            ...resetProps,
            filterVal,
            filterLoading,
          }),
        )
      }
    </Service>
  );
};

export default MapService;
